module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="manual-components"><fieldset><legend v-show="\'thermostat\' === mode">'+
((__t=( i18n.tc("ManualZone", "Set the target temperature to the specified value") ))==null?'':__t)+
'</legend><legend v-show="\'regulator\' === mode">'+
((__t=( i18n.tc("ManualZone", "Set the active level to the specified value") ))==null?'':__t)+
'</legend><div><div data-container="manual-temperature"><span v-show="\'thermostat\' === mode" class="manual-name">'+
((__t=( i18n.tc( "ZoneManual", "Temperature" ) ))==null?'':__t)+
' </span><span v-show="\'regulator\' === mode" class="manual-name">'+
((__t=( i18n.tc( "ZoneManual", "Active" ) ))==null?'':__t)+
' </span><span v-show="currentLevelValue" class="slider-degrees manual-degrees">{{ currentLevelValue }}{{ tempUnit }}</span></div></div><div><input type="range" v-model="currentLevelValue" :max="max" :min="min" :disabled="disableSlider" @touchend="save" @click="save"></div><p v-show="modelError" class="error">ERROR! {{ modelError }}</p><p v-show="currentValueError" class="error">ERROR! {{ currentValueError }}</p><p v-show="modeError" class="error">ERROR! {{ modeError }}</p><p v-show="onOffError" class="error">ERROR! {{ onOffError }}</p></fieldset><fieldset class="button-wrap"><button data-click="manual-number-cancel">'+
((__t=( i18n.tc("ManualZone", "Back") ))==null?'':__t)+
'</button></fieldset></div>';
}
return __p;
};
